import { render, staticRenderFns } from "./lkuSalesbinder.vue?vue&type=template&id=a019900a"
import script from "./lkuSalesbinder.vue?vue&type=script&lang=js"
export * from "./lkuSalesbinder.vue?vue&type=script&lang=js"
import style0 from "./lkuSalesbinder.vue?vue&type=style&index=0&id=a019900a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports